const asanaWebhookTriggerDefaults = {
  workspaceGid: '',
  resourceType: 'project',
  resourceGid: '',
  filterAction: 'all',
  filterResourceType: 'all',
};

export default asanaWebhookTriggerDefaults;
